import moment from "moment";
import { DATE_TIME_FORMATE, dictionary, INPUT_DATE_TIME_FORMATE } from "../constant";

export const defaultOnClick = () => {
	alert("Button Clicked");
};

type TransformOptions = Record<string, string | number>;

export const translatePhrase = (key: string, language: string = "en", placeholders: TransformOptions = {}): string => {
	// Example dictionary for different languages

	// Get the language dictionary
	const phrases = dictionary[language] || dictionary["en"];
	const template = phrases[key];

	if (!template) {
		console.warn(`Key "${key}" not found for language "${language}"`);
		return key; // Fallback to the key itself
	}

	// Replace placeholders in the template
	return template.replace(/\{(\w+)\}/g, (_: any, placeholder: any) => {
		return placeholders[placeholder]?.toString() || `{${placeholder}}`;
	});
};

export const debounce = (func: any, delay: number) => {
	let timeoutId: any;
	return function (this: any, ...args: any[]) {
		const context = this;
		clearTimeout(timeoutId);
		timeoutId = setTimeout(() => func.apply(context, args), delay);
	};
};

export const isNil = (data: any) => data === null || data === undefined;
export function maskFloat(amount: number | string, decimal?: number) {
	if (!amount || !Number(amount)) {
		amount = 0.0;
	}
	const decimalPlaces = getDecimalPlaces(amount);

	let data = Number(amount).toFixed(decimal || (decimalPlaces === 3 ? 3 : 2));
	return data;
}
export const getDecimalPlaces = (input: number | string) => {
	const number = Number(input);
	if (isNaN(number) || Number.isInteger(number)) {
		return 0;
	} else {
		const decimalPart = number.toString().split(".")[1];
		return decimalPart?.length;
	}
};

export const utcToLocalTime = (inputDate: string, format: string = DATE_TIME_FORMATE, inputFormat: string = INPUT_DATE_TIME_FORMATE) => {
	return inputFormat ? moment.utc(inputDate, inputFormat).local().format(format) : moment.utc(inputDate).local().format(format);
};

export const showTime = (DateTime: string, output_date_format: string = DATE_TIME_FORMATE, input_date_format: string = INPUT_DATE_TIME_FORMATE) => {
	if (!DateTime) {
		return translatePhrase("noDataAvailable");
	}
	return utcToLocalTime(DateTime, output_date_format, input_date_format);
};
export const insertLocalTimeInString = (str: string) => {
	const datetimeMatch = str.match(/<payzli_closure_date>(\d{8}-\d{6})<payzli_closure_date>/);
	let modifiedDate = "";
	if (!datetimeMatch) return str;
	modifiedDate = utcToLocalTime(datetimeMatch[1], DATE_TIME_FORMATE, "YYYYMMDD-HHmmss");
	return str.replace(/<payzli_closure_date>(\d{8}-\d{6})<payzli_closure_date>/, ` ${modifiedDate}`);
};
